import { render, staticRenderFns } from "./UnableToShip.vue?vue&type=template&id=13127c86&"
import script from "./UnableToShip.vue?vue&type=script&lang=js&"
export * from "./UnableToShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports